import { jsx as g, jsxs as y } from "react/jsx-runtime";
import { c as D } from "react/compiler-runtime";
import { Typography as C, Box as b, Grid as R } from "@mui/material";
import _ from "@mui/icons-material/CloseRounded";
const L = (P) => {
  const e = D(23), {
    presetOptions: p,
    activePreset: s,
    onPresetChange: t,
    isLive: o,
    isRangeOnly: a
  } = P, A = Math.ceil(p.length / 2);
  let f;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = {
    display: "flex",
    flexDirection: "column"
  }, e[0] = f) : f = e[0];
  let d;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = {
    fontSize: "13px",
    fontWeight: "600",
    lineHeight: "15px",
    color: "#878787",
    padding: "6px"
  }, e[1] = d) : d = e[1];
  const h = o ? "Live Data Presets" : "Data Presets";
  let i;
  e[2] !== h ? (i = /* @__PURE__ */ g(C, { sx: d, children: h }), e[2] = h, e[3] = i) : i = e[3];
  const v = `repeat(${A}, 1fr)`;
  let l;
  e[4] !== v ? (l = {
    display: "grid",
    gridTemplateRows: v,
    gap: "4px",
    gridAutoFlow: "column",
    gridAutoColumns: "1fr 1fr"
  }, e[4] = v, e[5] = l) : l = e[5];
  let n;
  if (e[6] !== s || e[7] !== o || e[8] !== a || e[9] !== t || e[10] !== p) {
    let x;
    e[12] !== s || e[13] !== o || e[14] !== a || e[15] !== t ? (x = (c) => {
      const u = c.value === s.value;
      return /* @__PURE__ */ y(b, { onClick: () => {
        u || t(c);
      }, sx: {
        display: "flex",
        alignItems: "center",
        gap: "4px",
        cursor: u ? "default" : "pointer",
        padding: "6px",
        borderRadius: "4px",
        backgroundColor: u ? "#E9F0EE" : "transparent",
        width: "max-content",
        position: "relative"
      }, children: [
        /* @__PURE__ */ g(C, { sx: {
          fontSize: "13px",
          fontWeight: "500",
          lineHeight: "15px",
          color: "#226A58"
        }, children: c.label }),
        u && o && !a && c.value !== "custom" && /* @__PURE__ */ g(_, { onClick: (S) => {
          S.stopPropagation(), t({
            label: "Custom",
            value: "custom"
          });
        }, sx: {
          fontSize: "14px",
          color: "#226A58",
          cursor: "pointer"
        } })
      ] }, c.value);
    }, e[12] = s, e[13] = o, e[14] = a, e[15] = t, e[16] = x) : x = e[16], n = p.map(x), e[6] = s, e[7] = o, e[8] = a, e[9] = t, e[10] = p, e[11] = n;
  } else
    n = e[11];
  let r;
  e[17] !== l || e[18] !== n ? (r = /* @__PURE__ */ g(R, { container: !0, sx: l, children: n }), e[17] = l, e[18] = n, e[19] = r) : r = e[19];
  let m;
  return e[20] !== i || e[21] !== r ? (m = /* @__PURE__ */ y(b, { sx: f, children: [
    i,
    r
  ] }), e[20] = i, e[21] = r, e[22] = m) : m = e[22], m;
};
export {
  L as LiveDataPresetsMenu
};
